import React from "react";
import { Backdrop, Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { colors } from "../../theme/colors";
import Loader from "./loader";

export default function OverlayLoader({ open }) {
    return (
        <Backdrop
            open={open}
            sx={{
                zIndex: (theme) => theme.zIndex.modal + 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "1.25rem",
                backgroundColor: alpha(colors.background.base, 0.78),
                backdropFilter: "blur(6px)",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transform: "scale(2)",
                    transformOrigin: "center",
                }}
            >
                <Loader />
            </Box>
            <Typography
                variant="body2"
                sx={{
                    color: colors.text.primary,
                    letterSpacing: "0.04em",
                    textAlign: "center",
                    maxWidth: "17rem",
                    px: 2,
                }}
            >
                Loading…
            </Typography>
        </Backdrop>
    );
}
